import { NavigateProps } from 'react-router-dom'

// Type for making other type partial
export type PartialType<T> = { [P in keyof T]?: T[P] }

export type ConfigType = {
  basePath: string | null
  featureToggle: {
    data: {
      exportInvoicePDF?: string
      exportInvoiceSpecificationExcel?: string
      invoiceRecipientAdmins?: string  
    }
  }
  api: string
  lang: string
  appName: string
  keycloak?: {
    origin: string
    url: string
    realm: string
    clientIds: {
      [key: string]: any
    }
    queryParams?: {
      [key: string]: any
    }
    logoutRedirectUri?:
      | string
      | {
          [key: string]: any
        }
  }
  menu?: {
    [key: string]: any
  }
  locations: { [to: string]: NavigateProps }
}

export enum ConfigDestinationTypes {
  HISTORY_BACK = 'HISTORY_BACK',
}

export interface StorageType {
  getItem<T = any>(key: string): T
  setItem<T>(key: string, value: T): T
  removeItem(key: string): void
  clear(): void
  key(keyIndex: number): string
  keys(): string[]
  iterate?<T, U>(
    iteratee: (value: T, key: string, iterationNumber: number) => U
  ): U
}

export enum AdminTypes {
  MMB_ADMIN = 'MMB_ADMIN',
  ORG_ADMIN = 'ORG_ADMIN',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  INVOICE_RECIPIENT_ADMIN = 'INVOICE_RECIPIENT_ADMIN',
}

export type LoginOrgAccountType = {
  orgAccountId: string
  orgAccountName: string
  mainAccount?: boolean
  accountAdmin?: boolean
  orgKimId?: number
}

export type LoginOrganizationType = {
  orgNumber: string
  orgName: string
  administratorType: AdminTypes
  orgKimId?: number
  orgAccounts: LoginOrgAccountType[]
}

export type LoginType = {
  // The url logged in from for redirection after logout
  loginUrl?: string
  isAuthenticated: boolean
  isLoggedIn: boolean
  administratorType: AdminTypes | null
  kimId: number | null
  personalId?: string
  name?: string
  firstName?: string
  lastName?: string
  userType?: string
  // Current organization & account
  orgKimId?: number
  orgNumber?: string
  orgName?: string
  orgAccountId?: string
  orgAccountName?: string
  // Available organization & accounts
  organizations?: LoginOrganizationType[]
  inkopBackofficeManager?: boolean
  hasAccessToNyKund?: boolean
}

export enum AlertLevels {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export type AlertType = {
  level: AlertLevels
  message: string | React.ReactNode
  data?: any
}

export type ErrorType = AlertType | Error | string | any

export interface APIState {
  isLoading: boolean
  error: ErrorType | null
  data?: any
}

export interface APIActions {
  type: string
  error?: ErrorType | null
  [data: string]: any | null | any[]
}

export type RenderableType =
  | string
  | React.ComponentElement<any, any>
  | React.ClassType<any, any, any>
  | ((
      ...args: any[]
    ) =>
      | string
      | React.ComponentElement<any, any>
      | React.ClassType<any, any, any>)

export type PersonType = {
  kimId?: number
  personalId?: string
  firstName: string
  lastName: string
  email: string
  telephoneNumber: string
}

export type TranslationOptionsType = {
  formats: {
    dateLong: string
    dateTimeLong: string
    dateShort: string
    dateTimeShort: string
  }
  names: {
    months: string[]
    monthsShort: string[]
  }
  price: {
    currencyShort: string
    decimalSymbol: string
  }
}
export type TranslationPluralsType = {
  param: string 
  [count: string]: string
}
export type TranslationMapType = {
  [key: string]: string | TranslationPluralsType
}

export interface LocaleInterface {
  lang: string
  translations: TranslationMapType
  options: TranslationOptionsType

  hasTranslation: (key: string) => boolean
  translate: (key: string, params?: { [key: string]: any }) => string
  selectTranslation: (
    selector: any,
    selections: { [key: string]: string }
  ) => string
  formatDatetime: (utcDatetime: number | string, format: string) => string
  formatPrice: (
    price: number | string,
    decimals?: number,
    separator?: string
  ) => string
  formatRoundedPrice: (
    price: number | string,
    decimals?: number,
    separator?: string
  ) => string
  formatOrgNumber: (orgNumber: string) => string
  formatPersonalId: (personalId: string) => string
  formatZipCode: (zipCode: string) => string
}

export enum FoodCompanyOptions {
  YES = 'YES',
  NO = 'NO',
}
